<div class="otp-input-container">
  <div class="otp-fields">
    <input
      *ngFor="let digit of otpDigits; let i = index"
      type="text"
      inputmode="numeric"
      pattern="[0-9]*"
      maxlength="1"
      class="otp-input"
      [formControl]="digitControls[i]"
      [readonly]="readOnly"
      (input)="onOtpInput($event, i)"
      (keydown)="onOtpKeyDown($event, i)"
      (paste)="onOtpPaste($event)"
      autocomplete="off"
    />
  </div>
</div>

